import React from 'react';

const GOLD = '#C9A84C';

export default function SectionTitle({ title, subtitle, gold, expanded, onToggle }) {
  return (
    <div style={{ marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, color: gold ? GOLD : 'var(--text-primary)', letterSpacing: '-0.02em', margin: 0 }}>
        {title}
      </h2>
      {subtitle && <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{subtitle}</span>}
      <div style={{ flex: 1 }} />
      {onToggle && (
        <button
          onClick={onToggle}
          title={expanded ? 'Collapse to row' : 'Expand to grid'}
          style={{
            background: 'none', border: 'none', cursor: 'pointer', padding: 4, borderRadius: 6,
            color: expanded ? GOLD : 'var(--text-tertiary)', display: 'flex', alignItems: 'center',
            transition: 'color 0.15s, background 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.color = GOLD; e.currentTarget.style.background = 'rgba(201,168,76,0.08)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = expanded ? GOLD : 'var(--text-tertiary)'; e.currentTarget.style.background = 'none'; }}
        >
          {expanded ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="18 15 12 9 6 15" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}
